export default "__VITE_ASSET__DtiyHUQn__"